import React from 'react';

import DismissableTooltip from './dismissable-tooltip';

import styles from './page-height-warning.scss';

const heightLimits = {
  desktop: 100,
  mobile: 200,
};

export default function PageHeightWarning({breakpointName, pageHeight}) {
  const heightLimit = heightLimits[breakpointName] || heightLimits.desktop;

  return (
    <DismissableTooltip
      arrow={false}
      bouncy={false}
      className={styles.tooltip}
      colour='yellow'
      visible={pageHeight > heightLimit}
    >
      Heads up! An excessive height could adversely affect your search rankings.
    </DismissableTooltip>
  );
}

PageHeightWarning.propTypes = {
  breakpointName: React.PropTypes.oneOf(['desktop', 'mobile']).isRequired,
  pageHeight: React.PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src/ui/components/page-height-warning.jsx